import { HtmlContentHeuristic } from '../../../interfaces/html-content-heuristic';
import { tableAncestor } from '../html-content-properties/table-ancestor';

// break when the text is in a different table than before
export const breakOnTableChange: HtmlContentHeuristic = {
  reason: 'table changed',
  evaluate: (next: Record<string, any>, prev: Record<string, any>) => prev.table != null && next.table !== prev.table,
  properties: [tableAncestor]
};
